module.exports = {
  "zones": {
    "Africa/Maputo": ["z", {
      "wallclock": -2109283200000,
      "format": "CAT",
      "abbrev": "CAT",
      "offset": 7200000,
      "posix": -2109291020000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 7820000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};